<div class="mx-1 card5 shadow  flex ">

    <div class="p-1 custom-input-container line1">
        <i class="me-2 " data-feather="package" [size]="23"></i>
        <h5 class=" mb-0 size18" >Informations sur le produit</h5>

    </div>
    <div>
        <table class="table-responsive">
            <tbody>
            <tr>
                <th>Type</th>
                <td >{{ productData.type }}</td>
            </tr>
            <tr>
                <th>Marque</th>
                <td >{{ productData.marque?.libelle }} </td>
            </tr>
            <tr>
                <th>Unité</th>
                <td>{{ productData.unite?.libelle }}</td>
            </tr>
            <tr>
                <th>Référence interne</th>
                <td>{{ productData.ref_interne }}</td>
            </tr>
            <tr>
                <th>Référence fabricant</th>
                <td>{{ productData.ref_fabricant }}</td>
            </tr>
            <tr>
                <th>Description</th>
                <td>{{ productData.description }}</td>
            </tr>
            </tbody>
        </table>


    </div>

</div>